<template>
  <card title="Medical services">
    <el-select
      v-model="form.services"
      value-key="id"
      multiple
      filterable
      placeholder="Pick services..."
      no-data-text="No data"
      no-match-text="No match"
      style="width: 100%"
    >
      <el-option-group
        v-for="group in groupedServices"
        :key="group.type"
        :label="group.label"
      >
        <el-option
          v-for="s in group.items"
          :key="s.id"
          :label="(s.name && (s.name.en || s.name.ru)) || s.id"
          :value="s"
        />
      </el-option-group>
    </el-select>
    <small class="text-muted d-block mt-2">
      <slot />
    </small>
  </card>
</template>

<script>
export default {
  name: "OfferFormMedicalServicesCard",
  props: {
    form: { type: Object, required: true },
    groupedServices: { type: Array, required: true }
  }
};
</script>
